import React from "react";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";

import { useRoles } from "@scenes/safeguard";
import { Roles } from "@scenes/safeguard/types";
import { FolderIcon } from "@common/folderIcon";
import { ZoneAvatar } from "@common/zoneAvatar";
import { Cell } from "./cell";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectRow(props: Props) {
  const navigate = useNavigate();
  const [planzoneRole] = useRoles({});
  const canNavigateToProject =
    planzoneRole.name === Roles.Admin || props.project.projectMember;

  return (
    <div className={styles.row}>
      <div className={styles.projectCell}>
        <div className={styles.zone}>
          <ZoneAvatar {...props.project.zone} />
        </div>
        <FolderIcon className={styles.icon} />
        <p
          className={classNames(styles.name, {
            [styles.clickable]: canNavigateToProject,
          })}
          onClick={() =>
            canNavigateToProject && navigate(`/projects/${props.project.uuid}`)
          }
        >
          {props.project.name}
        </p>
      </div>
      {props.project.periods.map((period, index) => (
        <Cell key={index} period={period} locale={props.locale} />
      ))}
    </div>
  );
}

export { ProjectRow };
